import { FormStore } from '@roc/feature-app-core';
import { createCurrencyField } from '../../../components/temp/componentBuiderTemp';
import { observer } from 'mobx-react';


export const AnnualTaxes = observer(({ store }: { store: FormStore }) => {
  return (
    <>
      {createCurrencyField({
        label: "Annual Taxes",
        fieldName: 'totalGrossAnnualTaxes',
        testId: 'totalGrossAnnualTaxes',
        store,
        standaloneLabel: false,
        addMarkForRequiredFields: true,
        isRequired: true
      })}
    </>
  );
});